// extracted by mini-css-extract-plugin
export default {"allDressSearchContainer":"dressNotFound_allDressSearchContainer__dEa5J","modifySearchButton":"dressNotFound_modifySearchButton__p1pzE","imgEmpty":"dressNotFound_imgEmpty__k58Gt"};